<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button routerLink="/about">
        <ion-icon name="menu"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="displayMenu(1)">
        <ion-icon name="list"></ion-icon>
      </ion-button>
      <ion-button (click)="displayMenu(2)">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>  
      <!--ion-button (click)="displayMenu(3)">
        <ion-icon name="options"></ion-icon>
      </ion-button-->
    </ion-buttons>
    <ion-title>
      &nbsp;Guitar Open Tuning Reference
    </ion-title>
  </ion-toolbar>
</ion-header>

<bullet-menu
  *ngIf="platform.width() > 600"
  [selected]="currentChapterIndex"
  [choices]="chapterNames"
  (select)="goToChapter($event)">
</bullet-menu>
<!--------------------------------- Menus --------------------------->
<div 
  *ngIf="menuVisible1 || menuVisible2 || menuVisible3" 
  class="backdrop"
  (click)="displayMenu(0)">
</div>
<div class="popover-style-container" *ngIf="menuVisible1" >
  <div class="popover-style">
    <ion-list>
      <ion-item>
        <b>Tunings</b>
      </ion-item>
      <ion-item 
        *ngFor="let chapter of tuningsService.chapters; let i = index"
        (click)="goToChapter(i)" 
        color="{{(i === currentChapterIndex) ? 'light' : ''}}" 
        class="chapter">
        <ion-label>
          {{ chapter.titleEn }}
        </ion-label>
      </ion-item>
    </ion-list>
  </div>
</div>
<div class="popover-style-container" *ngIf="menuVisible2" >
  <div class="popover-style">
    <ion-list>
      <ion-item>
        <b>More</b>
      </ion-item>
      <ion-item>
        <ion-label>Lefty view</ion-label>
        <ion-checkbox mode="ios" [(ngModel)]="opt.lefty"></ion-checkbox>
      </ion-item>
      <ion-item
        (click)="displayMenu(0)"
        routerLink="/f/customize">
        <ion-label>Custom tuning</ion-label>
      </ion-item>
      <ion-item
        (click)="displayMenu(0)"
        routerLink="/about">
        <ion-label>About G.O.T.R.</ion-label>
      </ion-item>
    </ion-list>
  </div>
</div>
<div class="popover-style-container" *ngIf="menuVisible3" >
  <div class="popover-style">
    <ion-list>
      <ion-item>
        <b>Options</b>
      </ion-item>
      <!--ion-item>
        <ion-label>With text</ion-label>
        <ion-checkbox mode="ios" [(ngModel)]="opt.withText"></ion-checkbox>
      </ion-item -->
    </ion-list>
  </div>
</div>
<!--------------------------------- Content --------------------------->
<ion-content color="light" class="ion-text-center">
  <br/>
  <div [ngStyle]="{
    'max-width': '1300px',
    'text-align': 'left',
    'display': 'inline-block',
    'width': '92%',
    'margin-top': '12px'
    }"
    *ngFor="let currentChapter of [this.tuningsService.chapters[this.currentChapterIndex]]">
    <ion-title>{{ currentChapter.titleEn }} </ion-title>
    <ion-card *ngIf="currentChapter.description">
      <ion-card-content>
          {{ currentChapter.description }}
      </ion-card-content>
    </ion-card>
    <div 
      *ngFor="let tuning of this.getTunings(); let tuningIndex = index">
      <ion-card>
        <ion-card-header>
          <ion-card-title>
            <div class="content-title">
              {{tuning.name}}
            </div>
          </ion-card-title>
        </ion-card-header>
        <ion-grid class="incard">
          <ion-row>
            <ion-col size="4">Tuning:</ion-col>
            <ion-col 
              *ngFor="let note of tuning.notes.split(' ')" 
              [ngStyle]="{
                'color': 'blue',
                'font-size': '90%'
              }" 
              text-center>
              {{note}}
            </ion-col>
          </ion-row>
          <ion-row *ngIf="tuning.intervals.length > 0">
            <ion-col size="4">Intervals:</ion-col>
            <ion-col 
              *ngFor="let interval of tuning.intervals.split(' ')"
              text-center>
              {{interval}}
            </ion-col>
          </ion-row>
          </ion-grid>
          <ion-button *ngIf="withDescriptionToggleOption"
            type="bar-button" color="primary" size="small"
            (click)="description[tuningIndex] = !description[tuningIndex]"
            fill="{{description[tuningIndex]?'solid':'outline'}}">
            Description
          </ion-button>
          <div class="incard" 
            *ngIf="(showFretboard === tuningIndex)"
            [ngStyle]="{'width': '220px'}">
            <ion-select
              (ionChange)="refreshFretboard()"
              [(ngModel)]="selectedNote12String" placeholder="Root note">
              <ion-select-option 
                value="{{ note12 }}"
                *ngFor="let root of notesService.all; let note12 = index">
                {{root}}
              </ion-select-option>
            </ion-select>
            <ion-select
              (ionChange)="refreshFretboard()"
              [(ngModel)]="selectedCSIndexString" placeholder="Chord / Scale">
              <ion-select-option 
                value="{{ i }}"
                *ngFor="let cs of CS; let i = index">
                {{cs}}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="fretboard">
            <fretboard
              [cssForFretboard]="{'margin': '12px 0 4px 0'}"
              *ngIf="(showFretboard == tuningIndex)"
              [displayParams]="{
                lefty: opt.lefty,
                openTuning6: tuning.notes,
                withDetuneStrings: true
              }"
              [displayChordScale]="CSValue">
            </fretboard>
            <div (click)="toggleFretboard(tuningIndex)" [style.cursor]="'pointer'">
              <span>Fretboard</span>
              <ion-icon  
                [ngStyle]="{
                  'font-size': '1.6em',
                  'vertical-align': 'bottom',
                  'margin-left': '10px'
                }"       
                name="{{ (showFretboard === tuningIndex) ? 'caret-up-sharp' : 'caret-down-sharp' }}">
              </ion-icon>
            </div>
          </div>
          <ion-card-content *ngIf="(description[tuningIndex] && opt.withText)">
            <app-tuning-text [tuning]='tuning'></app-tuning-text>
            <br/>
          </ion-card-content>
      </ion-card>
    </div> 
  </div>
  <br />
  <br />
  <br />
  <br />
</ion-content>
